import { render, staticRenderFns } from "./HistoryListItemLayout.vue?vue&type=template&id=850aac74&scoped=true&"
import script from "./HistoryListItemLayout.vue?vue&type=script&lang=js&"
export * from "./HistoryListItemLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850aac74",
  null
  
)

export default component.exports